<template>

  <div id="listHeader">
    
    <v-btn flat fab small class="vo-icon-button" @click="openFilter">
      <v-icon medium>mdi-tune</v-icon>
    </v-btn>

    <div v-if="page.subtitle" class="subtitle">{{ page.subtitle }}</div>

    <div v-if="!page.filtering || showSortingOptions" class="sorts">
      
      <div class="sort" v-for="(sort, key) in page.sort.options" :key="key" :class="{selected: (page.sort.value === key)}" @click="sortClicked(sort, key)">
        <div class="item-title">{{ sort.title }}</div>
        <div v-if="key == page.sort.value" class="item-icon">
          <i class="mdi mdi-24px mdi-menu-up" :class="{'mdi-flip-v': (sort.value < 0)}"></i>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <div v-else class="search">
      <div class="search-text">Searching "{{ page.filtering.search.value }}"</div>
      <div class="clear" @click="clearSearch">Clear</div>
    </div>
  </div>

</template>

<script>

  export default {
    
    data () {
      return {

      }
    },
    
    props: {
      page: {
        required: true
      }
    },
    
    methods: {
      
      clearSearch () {
        this.page.filtering.search.value = '';
      },

      sortClicked (sort, key) {
        if (key === this.page.sort.value) this.page.sort.options[key].value = -this.page.sort.options[key].value;
        else this.page.sort.value = key;
        
        // Save to local storage
        var current = {};
        var routeName = this.$route.name;
        if (localStorage.getItem(routeName)) {
          current = JSON.parse(localStorage.getItem(routeName));
        }
        
        current.sort = {
          key: key,
          value: this.page.sort.options[key].value
        };

        localStorage.setItem(routeName, JSON.stringify(current));
      },

      openFilter () {
        this.routeAddQuery('filter');
      },

    },

    computed: {
      showSortingOptions () {
        var noSearch = this.page.filtering && !this.page.filtering.search;
        var searchEmpty = this.page.filtering && this.page.filtering.search && (!this.page.filtering.search.value || this.page.filtering.search.value.length === 0);

        return noSearch || searchEmpty;
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #listHeader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-bottom: $borderBlack12;

    .vo-icon-button {
      display: none;
    }

    .subtitle {
      display: none;
    }

    .sorts {
      position: absolute;
      right: 8px;

      .sort {
        float: left;
        height: 48px;
        line-height: 48px;
        padding: 0 6px;
        cursor: pointer;
        user-select: none;

        @include fontPrimary500();
        letter-spacing: .5px;
        text-transform: uppercase;
        font-size: 12px;
        color: $black54;

        .item-title {
          float: left;
        }

        .item-icon {
          float: left;
          width: 24px;
          height: 24px;
        }

        &.selected {
          color: $black87;

          .icon-item i {
            color: $black87;
          }
        }

      } // .sort

    } // .sorts


    .search {
      
      font-size: 12px;
      line-height: 48px;
      letter-spacing: .5px;

      .search-text {
        @include fontPrimary500;
        @include textEllipsis;
        width: calc(100% - 78px);
        color: $primary;
        padding: 0 16px;
        text-transform: uppercase;
      } 

      .clear {
        position: absolute;
        top: 0;
        right: 0;
        width: 60px;
        bottom: 0;
        cursor: pointer;
        text-align: center;

        @include fontPrimary500;
        color: $error_red;
        text-transform: uppercase;
      }
    }

    @media screen and (max-width: 1000px) {
      
      .vo-icon-button {
        display: block;
        position: absolute;
        top: 3px;
        left: 3px;
        bottom: 0;
        margin: 0;
      }

      .subtitle {
        @include fontPrimary500();
        @include title();

        display: block;
        position: absolute;
        top: 14px;
        left: 64px;
        color: $black54;
        font-size: 14px;
      }

      .search {
      
        .search-text {
          padding: 0 16px 0 48px;
        }
      } 

    }
  }

</style>


// WEBPACK FOOTER //
// src/components/ListHeader.vue